import { render, staticRenderFns } from "./CustomerBinding.vue?vue&type=template&id=4977eb9e&scoped=true&"
import script from "./CustomerBinding.vue?vue&type=script&lang=js&"
export * from "./CustomerBinding.vue?vue&type=script&lang=js&"
import style0 from "./CustomerBinding.vue?vue&type=style&index=0&id=4977eb9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4977eb9e",
  null
  
)

export default component.exports